import React from 'react';
import { useTranslation } from 'react-i18next';
import PieChart from '../charts/PieChart'
import BlockChart from "../BlockChart";

const VendorConsent = ({data = [], loaderProps}) => {
  const defaultData = [{"name":"yes","y":0},{"name":"no","y":0}]
  const { t } = useTranslation();

  const chartData = data.reduce((acc, current) => {
    if (current.spt_consent) {
      acc[0].y += current.active_devices
    } else {
      acc[1].y += current.active_devices
    }
    return acc
  }, [...defaultData] )

  return (
    <BlockChart title={t("publisher.vendorConsent")} {...loaderProps}>
      <PieChart data={chartData}/>
    </BlockChart>
  )
}

export default VendorConsent
